export interface Story {
  id: string;
  tag: string;
  heat: string;
  status: string;
  tone: 'primary' | 'accent' | 'secondary';
  title: string;
  digest: string;
  updated: string;
  talks: string;
  verify: string;
}

export const trendingStories: Story[] = [
  {
    id: 'story-1',
    tag: '头部主播 · 选品争议',
    heat: '高热度',
    status: '当事人已回应 · 待核实',
    tone: 'primary',
    title: '头部主播就“选品记录缺失”二次回应，称将分批公开品控台账',
    digest: '继首份声明被指“话术回避”后，当事人更新第二版回应，承诺按批次公开品控与检测记录，反转仍在观察。',
    updated: '更新于 2 小时前',
    talks: '4.2k',
    verify: '待核实',
  },
  {
    id: 'story-2',
    tag: '平台 · 抽成调整',
    heat: '高热度',
    status: '反转观察中',
    tone: 'accent',
    title: '平台深夜发文回应抽成分成调整，多方博主称将联合晒后台截图',
    digest: '官方口径与早前宣传不一致，出现“口径前后对不上”的疑点，是否构成误导仍待更多证据链。',
    updated: '更新于 3 小时前',
    talks: '6.8k',
    verify: '疑点待证',
  },
  {
    id: 'story-3',
    tag: '高层 · 离职传闻',
    heat: '中热度',
    status: '正在反转',
    tone: 'secondary',
    title: '高层“架空离职”传闻发酵，当事人晒时间线与沟通记录反驳',
    digest: '爆料指向离职时间与节点不实，当事人给出反向证据，事件出现明显反转信号。',
    updated: '更新于 5 小时前',
    talks: '1.9k',
    verify: '倾向反转',
  },
  {
    id: 'story-4',
    tag: '加盟招商 · 承诺问题',
    heat: '中热度',
    status: '跟进中',
    tone: 'primary',
    title: '多名加盟商控诉招商话术夸大，官方称将统一核查后单独回应',
    digest: '书面承诺与口头话术被指不一致，官方目前仅回应“核查中”，未给出明确时间表。',
    updated: '更新于 8 小时前',
    talks: '3.1k',
    verify: '跟进中',
  },
  {
    id: 'story-5',
    tag: '测评 · 数据争议',
    heat: '低热度',
    status: '疑点待证',
    tone: 'accent',
    title: '第三方测评数据疑遭二次加工，机构预告放出未剪辑原始报告',
    digest: '榜单名次与公开检测值存在出入，原始数据若公开可验证传闻真伪，进度值得长期跟进。',
    updated: '更新于 12 小时前',
    talks: '860',
    verify: '等待公开',
  },
  {
    id: 'story-6',
    tag: '股权 · 代持传闻',
    heat: '低热度',
    status: '持续追踪',
    tone: 'secondary',
    title: '“股权代持”传闻持续发酵，律师声明与工商记录现出入',
    digest: '口径与登记信息对不上，知情方表示将在本周提供完整文件，事件走向待后续进展更新。',
    updated: '更新于 1 天前',
    talks: '1.2k',
    verify: '待资料',
  },
];

export interface FeedItem {
  id: string;
  time: string;
  tag: string;
  title: string;
  tone: 'primary' | 'accent' | 'secondary';
}

export const feedItems: FeedItem[] = [
  { id: 'feed-1', time: '09:40', tag: '平台抽成', title: '官方更新第三版回应，新增一页明细截图，未提关键数据口径', tone: 'accent' },
  { id: 'feed-2', time: '08:12', tag: '离职传闻', title: '当事人补充入职-离职时间线聊天记录，指报道“拼接失实”', tone: 'secondary' },
  { id: 'feed-3', time: '07:05', tag: '加盟商', title: '一名加盟商放出签约现场录音片段，官方暂未正式回应', tone: 'primary' },
  { id: 'feed-4', time: '昨日 22:30', tag: '测评机构', title: '机构预告将在 48 小时内放出未剪辑的原始检测数据', tone: 'accent' },
  { id: 'feed-5', time: '昨日 20:14', tag: '股权代持', title: '档案库新增一份工商变更记录，与声明口径存在出入', tone: 'primary' },
];

export interface ResponseItem {
  id: string;
  who: string;
  quote: string;
  status: string;
  tone: 'primary' | 'accent' | 'secondary';
}

export const responses: ResponseItem[] = [
  {
    id: 'res-1',
    who: '平台运营方 · 深夜公告',
    quote: '关于抽成比例调整的说明存在表述不当，我们理解各方关注，将补充完整口径与历史版本对照。',
    status: '已回应 · 细节待证',
    tone: 'accent',
  },
  {
    id: 'res-2',
    who: '涉事主播 · 第二份声明',
    quote: '选品流程一直按规范执行，愿意分批公开可脱敏的品控台账，欢迎监督，不做删帖。',
    status: '已回应 · 资料待公开',
    tone: 'primary',
  },
  {
    id: 'res-3',
    who: '离职传闻当事人',
    quote: '所谓“被架空离职”与事实不符，我已整理时间线及沟通记录，供核实。',
    status: '已回应 · 证据待核验',
    tone: 'secondary',
  },
];

export interface TopicGroup {
  id: string;
  name: string;
  hint: string;
  tone: 'primary' | 'accent' | 'secondary';
  tags: { name: string; count: string }[];
}

export const topicGroups: TopicGroup[] = [
  {
    id: 'live',
    name: '直播跟进',
    hint: '正在逐条更新的跟踪报道',
    tone: 'accent',
    tags: [
      { name: '#平台抽成分成', count: '6.8k' },
      { name: '#头部主播选品', count: '4.2k' },
      { name: '#加盟招商承诺', count: '3.1k' },
      { name: '#供应链质检', count: '2.4k' },
    ],
  },
  {
    id: 'reversal',
    name: '待反转观察',
    hint: '出现新证据、方向待定的瓜',
    tone: 'primary',
    tags: [
      { name: '#离职时间线', count: '1.9k' },
      { name: '#测评数据', count: '860' },
      { name: '#代持传闻', count: '1.2k' },
      { name: '#口径前后不一', count: '980' },
    ],
  },
  {
    id: 'rising',
    name: '热度飙升',
    hint: '讨论量快速上涨、即将更新',
    tone: 'secondary',
    tags: [
      { name: '#录音曝光', count: '5.5k' },
      { name: '#后台记录', count: '2.1k' },
      { name: '#工商变更', count: '1.6k' },
      { name: '#未剪辑原片', count: '730' },
    ],
  },
  {
    id: 'archive',
    name: '已归档',
    hint: '已有阶段性结论、停止高频更新',
    tone: 'secondary',
    tags: [
      { name: '#辟谣定论', count: '12' },
      { name: '#旧瓜结案', count: '9' },
      { name: '#当事人致歉', count: '7' },
      { name: '#官网澄清', count: '11' },
    ],
  },
];

export interface ReversalCheck {
  id: string;
  label: string;
  percent: number;
  verdict: string;
  points: string[];
}

export const reversalChecks: ReversalCheck[] = [
  {
    id: 'rv-1',
    label: '平台抽成分成',
    percent: 62,
    verdict: '口径矛盾，存在反转可能',
    points: ['首版声明与宣传页比例不一致', '第三方博主将晒后台截图', '官方已承诺补充历史版本'],
  },
  {
    id: 'rv-2',
    label: '高层离职传闻',
    percent: 78,
    verdict: '已现明显反转信号',
    points: ['当事人提供完整时间线', '聊天记录可交叉核验', '爆料原文部分已删除'],
  },
  {
    id: 'rv-3',
    label: '选品品控争议',
    percent: 41,
    verdict: '证据未闭环，方向待定',
    points: ['品控台账尚未公开', '检测记录待二次核验', '缺乏第三方背书'],
  },
];

export interface FaqItem {
  id: string;
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    id: 'faq-1',
    q: '你们会一直跟到事件结局吗？多久更新一次？',
    a: '会。只要事件仍在发酵、当事人仍在回应、证据仍在变化，频道就会保持更新。热度下降或出现阶段性结论后，我们会把话题转入“已归档”，不再高频刷屏，但会保留历史进度供长期关注回看。',
  },
  {
    id: 'faq-2',
    q: '“当事人已回应”和“已证实”有什么区别？',
    a: '有本质区别。“已回应”只代表当事人给出过说法；“已证实”则要求说法得到独立证据或多方交叉验证。我们只会在证据链完整时使用更重的表述，避免把单方口径当成结论。',
  },
  {
    id: 'faq-3',
    q: '如果反转了，你们会删除之前的跟踪报道吗？',
    a: '不会删除，会改写并标注。反转是正常的信息过程，删掉反而会抹掉上下文。我们会把“原先口径”与“反转依据”并列保留，并打上更新时间与状态变更标记，方便判断来龙去脉。',
  },
  {
    id: 'faq-4',
    q: '消息来源如何核实？会不会误伤当事人？',
    a: '我们优先采用可追溯的公开来源，对匿名投稿标注“未证实”。在当事人尚未回应前，标题与正文只使用“传闻”“指控”“据称”等中性措辞，不预设结论，最大限度降低误伤。',
  },
  {
    id: 'faq-5',
    q: '我想投稿或提供线索，怎么联系？',
    a: '频道底部设有反馈入口，可提交带时间戳的截图、链接或文件。为保护投稿人，所有线索默认匿名处理，只有内容涉及重大公共利益时我们才会主动二次联系核实。',
  },
  {
    id: 'faq-6',
    q: '怎样持续关注，不错过任何一次剧情更新？',
    a: '可关注本频道主页或收藏入口。每当某事件出现当事人回应、新增证据或反转信号时，我们都会在“最新进展”区置顶标注，并在话题墙相应分组更新讨论热度。',
  },
];